import { Modal } from "@monsterindia/global-ui-components";
import { useEffect, useState } from "react";

import { API_ENDPOINT } from "../../../constants/appConstant";
import { SalaryModeOptions } from "../../../constants/employment";
import { useNetwork } from "../../../hooks/useNetwork";
import { SalaryNudgeType, UpdatedData } from "./Salary.types";
import { SalaryUI } from "./SalaryUI";

export const SalaryNudge = ({
  prefilledData,
  nextApopType,
  onCTA,
  toast,
  flowType,
  handleEventTracking,
  eventName,
  isL1Apop = false,
  screenAlignment,
  closeApop,
  onApopComplete,
  callOnCompleteBeforeClose,
}: SalaryNudgeType) => {
  const { fetchData: fetchAPI } = useNetwork();
  const { fetchData: submitAPI, response } = useNetwork();
  const [employmentData, setEmploymentData] = useState<any>(null);

  const fetchEmploymentData = async () => {
    const res = await fetchAPI(
      API_ENDPOINT().seekerProfile.getEmploymentDetailsMiddleware,
      "GET",
    );

    if (res.data) {
      setEmploymentData(res.data);
    }
  };

  useEffect(() => {
    if (!prefilledData.salaryPrefill?.employmentId) {
      fetchEmploymentData();
    }
  }, [prefilledData.salaryPrefill.employmentId]);

  const onSubmit = async (
    data: any,
    salaryMode: (typeof SalaryModeOptions)[0],
  ) => {
    const updatedData: UpdatedData = {
      employmentProfileId: prefilledData?.salaryPrefill?.employmentId
        ? prefilledData?.salaryPrefill?.employmentId
        : employmentData?.employmentDetailSection?.employments[0]?.id
          ? employmentData?.employmentDetailSection?.employments[0]?.id
          : null,
      salary: {
        currency: data.currency.text,
        absoluteValue: data.salary,
        salaryMode: {
          id: salaryMode.uuid,
        },
      },
    };

    if (data.hideSalary) {
      updatedData["salary"]["confidential"] = data.hideSalary;
    }

    const res = await submitAPI(
      API_ENDPOINT().seekerProfile.updateSalary,
      "PUT",
      {},
      updatedData,
    );

    if (res.data) {
      onCTA && onCTA("SALARY", updatedData);
      toast &&
        toast({
          showToast: true,
          text: "Salary details updated successfully.",
          type: "success",
        });

      if (prefilledData?.nextActionData) {
        nextApopType(
          prefilledData?.nextActionData?.actionType ?? "",
          prefilledData?.nextActionData ?? null,
        );
      }
      if (isL1Apop) {
        onCTA && onCTA("EMPLOYMENT");
      }
      if (callOnCompleteBeforeClose && flowType === "L1_APOP") {
        Promise.resolve(onApopComplete && onApopComplete())
          .then(() => {
            closeApop();
          })
          .catch((error) => {
            console.error("Error in onApopComplete:", error);
            closeApop();
          });
      } else {
        closeApop();
      }
    } else {
      toast &&
        toast({
          showToast: true,
          text:
            (res.error as any)?.error?.message?.errorMessage ??
            "Something went wrong",
          type: "error",
        });
      if (isL1Apop) {
        onCTA && onCTA("EMPLOYMENT");
      }
    }
  };

  return (
    <>
      {isL1Apop ? (
        <SalaryUI
          prefilledData={prefilledData}
          onSubmit={onSubmit}
          isSubmitAPILoading={response.isLoading}
        />
      ) : (
        <Modal
          showModal={true}
          closeModal={closeApop}
          isMobile={window.innerWidth < 768}
          showCloseButton={false}
          screenAlignment={screenAlignment ?? "right"}
          customClass="l1-apop-salary-nudge"
        >
          <SalaryUI
            prefilledData={prefilledData}
            onSubmit={onSubmit}
            isSubmitAPILoading={response.isLoading}
          />
        </Modal>
      )}
    </>
  );
};
